import PersonIcon from '@mui/icons-material/Person';
import { withClarityTheme } from '@verifime/styles';
import { EntityTypeTile } from '../EntityTypeTile';

export type IndividualTileProps = {
  /**
   * Whether this tile is currently selected
   */
  selected?: boolean;
  /**
   * Callback when the tile is clicked
   */
  onClick?: () => void;
  /**
   * Whether the tile is visible but cannot be chosen
   */
  disabled?: boolean;
  /**
   * Optional data-testid for testing
   */
  dataTestId?: string;
};

/**
 * IndividualTile is a pre-configured EntityTypeTile for the Individual choice: the customer
 * verifying only themselves, with no business, organisation or trust.
 *
 * @example
 * ```tsx
 * <IndividualTile
 *   selected={selected === 'individual'}
 *   onClick={() => onSelect('individual')}
 * />
 * ```
 */
const IndividualTileComponent = ({
  selected,
  onClick,
  disabled,
  dataTestId,
}: Readonly<IndividualTileProps>) => {
  return (
    <EntityTypeTile
      icon={<PersonIcon />}
      title="Individual"
      description="Just you as a person verifying your own identity."
      hint="Choose this if you're signing up in your own name and not for a business or trust."
      selected={selected}
      onClick={onClick}
      disabled={disabled}
      dataTestId={dataTestId}
    />
  );
};

export const IndividualTile = withClarityTheme(IndividualTileComponent);
